import React, { useEffect, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { formatPhoneNumber, emailValidationHelper, getConfigurationDataKey } from '../utils/helpers';
import { HcpButton } from './HcpButton';
import { ResourceContent } from '.';

const EditUserDetails = (props: any) => {
  const { handleClose, data, onSubmit, error, isLoading } = props;
  const [email, setEmail] = useState(data?.email);
  const [phone, setPhone] = useState(data?.cellNumber);
  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');

  useEffect(() => {
    handlePhoneInput(phone);
  }, []);

  const handleSubmit = () => {
    const result = onSubmit({ email, cellNumber: phone, userName: data?.userName });
    return;
  };

  const handlePhoneInput = (value: string) => {
    const formattedPhoneNumber = formatPhoneNumber(value);
    if (formattedPhoneNumber?.length && formattedPhoneNumber?.length < 14) {
      setPhoneError('User phone must have 10 digits');
    } else if (formattedPhoneNumber?.length === 0) {
      setPhoneError('');
    } else {
      setPhoneError('');
    }
    setPhone(formattedPhoneNumber);
  };

  const handleEmailInput = (value: string) => {
    if (value === '') {
      setEmailError('Email is a required field');
    } else if (emailValidationHelper(value)) {
      setEmailError('Email is invalid');
    } else {
      setEmailError('');
    }
    setEmail(value);
  };

  return (
    <div className='popup-box'>
      <div className='popup-box-container'>
        <div className='d-flex w-100 align-items-center justify-content-between'>
          <h5>Update User</h5>
          <div className='ms-auto d-flex'>
            <p className='required-text general-note mb-0 ms-3'>
              <ResourceContent contentKey={getConfigurationDataKey('general.required-fields-note')} />
            </p>
          </div>
          <button className='btn-close px-3' onClick={handleClose} aria-label='Close'></button>
        </div>
        {error && <p className='invalid-feedback-input'>{error}</p>}

        <Row className='form-row mt-3'>
          <Col md={6} className='form-group'>
            <label className='form-label'>Email Address:</label>
            <input
              type='text'
              className={emailError ? 'form-control is-invalid' : 'form-control'}
              value={email}
              onChange={(e) => handleEmailInput(e.target.value)}
            />
            {emailError && <p className='invalid-feedback-input'>{emailError}</p>}
          </Col>

          <Col md={6} className='form-group'>
            <label className='form-label'>Mobile Phone:</label>
            <input
              type='text'
              placeholder='(XXX) XXX-XXXX'
              className={phoneError ? 'form-control is-invalid' : 'form-control'}
              value={phone}
              onChange={(e) => handlePhoneInput(e.target.value)}
            />
            {phoneError && <p className='invalid-feedback-input'> {phoneError} </p>}
          </Col>
        </Row>

        <Row className='mt-4'>
          <Col className='d-flex flex-column flex-lg-row justify-content-md-start'>
            <HcpButton
              className='mb-2 mb-lg-0 mr-lg-2'
              variant='secondary-new'
              disabled={emailError.length + phoneError.length !== 0}
              onClick={handleSubmit}>
              Update User And Close
            </HcpButton>
            {isLoading && <Spinner animation='border' variant='secondary' />}
          </Col>
          <Col md={4} className='d-flex justify-content-md-end'>
            <HcpButton
              variant='outline-danger'
              className='mt-3 mt-md-0 btn btn-transparent cancel-button'
              onClick={handleClose}>
              Cancel
            </HcpButton>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default EditUserDetails;
